export var strokePresetColors = ['primary', 'blue', 'green', 'yellow', 'red'];
//# sourceMappingURL=types.js.map